import axios from 'axios';
import { formatCurrency, unescape } from 'utils/Formatters';

const getValue = data => {
  if(!data || data.length < 1) return '';

  return Array.isArray(data) ?  data[0] :  data;
};

const getAmount = data => {
  return formatCurrency(getValue(data));
};

export default {
  namespaced: true,
  state: {
    criteria: '',
    details: {},
    hasSearched: false,
    list: []
  },

  getters: {
    contact: state => {
      return getValue(state.details.contact);
    },

    email: state => {
      if (!state.details.contact_email) return '';

      return getValue(state.details.contact_email);
    },

    phone: state => {
      const phone = getValue(state.details.contact_phone);
      const match = phone.match(/^(\d{3})(\d{3})(\d{4})$/);
      return match ? `${match[1]}-${match[2]}-${match[3]}` : phone;
    },

    giftFormLink: state => {
      if(!state.details.online_resources|| !state.details.online_resources.online_resource) return '';

      return state.details.online_resources.online_resource.matching_gift_form;
    },

    guidelinesLink: state => {
      if (!state.details.online_resources || !state.details.online_resources.online_resource) return '';

      return state.details.online_resources.online_resource.guide;
    },

    minimumAmountMatch: state => {
      if (!state.details.giftratios) return '';

      return getAmount(state.details.giftratios.minimum_amount_matched);
    },

    maximumAmountMatch: state => {
      if (!state.details.giftratios) return '';

      return getAmount(state.details.giftratios.maximum_amount_matched);
    },

    totalPerEmployee: state => {
      if (!state.details.giftratios) return '';

      return getAmount(state.details.giftratios.total_amount_per_employee);
    },

    giftRatio: state => {
      if(!state.details.giftrations) return '';

      return getValue(state.details.giftrations.giftratio);
    },

    procedures: state => {
      if(!state.details.procedure) return '';

      let markup = '';
      for (var key in state.details.procedure) {
        if (state.details.procedure.hasOwnProperty(key)) {
          const procedure = state.details.procedure[key];
          if(procedure && procedure.length > 0) {
            markup += `* ${state.details.procedure[key]}<br>`
          }
        }
      }
      return unescape(markup.replace('\n', ''));
    },

    subsidiaries: state => {
      if (!state.details.subsidiaryof) return '';

      if(Array.isArray(state.details.subsidiaryof))
        return state.details.subsidiaryof.join();
      else {
        return state.details.subsidiaryof;
      }
    },

    comments: state => {
      if(!state.details.comments) return '';

      return unescape(getValue(state.details.comments));
    },

    emailHref: (state, getters) => {
      const emailString = encodeURI(`
        Company: ${state.details.name}
        Subsidiary of: ${getters.subsidiaries}
        Foundation Number: ${state.details.company_id}
        Last Updated: ${state.details.last_updated}
        Contact: ${getters.contact}
        Phone: ${getters.phone}
        Email: ${getters.email}
        Matching Gift Form: ${getters.giftFormLink}
        Matching Gift Guidelines:: ${getters.guidelinesLink}
        Minimum Amount Matched: ${getters.minimumAmountMatch}
        Maximum Amount Matched: ${getters.maximumAmountMatch}
        Total Per Employee: ${getters.totalPerEmployee}
        Gift Ratio: ${getters.giftRatio}
        Comments: ${getters.comments}
        Procedures: ${getters.procedures}
      `);

      return `mailto:?subject=Matching Gift Information for ${state.details.name}&body=${emailString}`;
    },

    printUrl: state => {
      return `/employerMatchPrint/${state.details.company_id}`;
    }
  },

  mutations: {
    setEmployers(state, employers) {
      state.list = employers;
    },

    setDetails(state, details) {
      state.details = details;
    }
  },

  actions: {
    /**
     * Method to search employer match participants by name.
     *
     * @param {string} name
     *   The partial or full name of the employer.
     */
    search({state, commit}, name) {
      let data = []
      axios.get(`/employer_match_search/${name}`)
        .then(function (response) {
          data = response.data;
          if (!Array.isArray(data)) {
            data = [data];
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(() => {
          state.hasSearched = true;
          state.criteria = name;
          commit('setEmployers', data);
        });
    },

    /**
     * This method gets the details for an employer match by id.
     *
     * @param {string} id
     *   The id of the employer.
     *
     * @return promise
     *   The promise is returned so that we can do other stuff after.
     */
    getDetails({commit}, id) {
      let data = {};
      return axios.get(`/employer_details/${id}`)
      .then(function (response) {
        data = response.data;
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(() => {
        commit('setDetails', data);
      });
    }
  }
};
